import React, { createContext, useContext } from 'react';

export type MaximizedPanel = 'grid' | 'map' | null;

export interface SelectDriversContextValue {
  routes: Array<{ driverId: string; [key: string]: unknown }>;
  selectedDriverIds: string[];
  onSelectionChange: (driverIds: string[]) => void;
  selectedPickupsList?: unknown[];
  userData?: unknown;
  glEventHub?: unknown;
  configJSON?: unknown;
  featureFlags?: { isFeatureEnabled: (name: string) => boolean };
  DispatchStore?: unknown;
  CommonStore?: unknown;
  quickFilterText: string;
  setQuickFilterText: (value: string) => void;
  maximizedPanel: MaximizedPanel;
  setMaximizedPanel: (panel: MaximizedPanel) => void;
}

const SelectDriversContext = createContext<SelectDriversContextValue | null>(null);

export const SelectDriversProvider = SelectDriversContext.Provider;

export function useSelectDriversContext(): SelectDriversContextValue {
  const value = useContext(SelectDriversContext);
  if (value == null) {
    throw new Error('useSelectDriversContext must be used within SelectDriversProvider');
  }
  return value;
}
